import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import "./AddPartner.scss";
import "../../styles/global.scss";
// Components
import Sidebar from "../components/sidebar/Sidebar";

// React Bootstrap components
import { Container, Row, Col } from "react-bootstrap";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import Tabs from "react-bootstrap/Tabs";
import Tab from "react-bootstrap/Tab";
// @ts-ignore
import PartnerOverviewForm from "../components/forms/partnerOverviewForm";
import PartnerServiceCapabilitiesNew from "./PartnerServiceCapabilitiesNew";
// import PartnerMOU from "./PartnerMOU";
import {
  GetAllCountries,
  GetMarketPresenceCountries,
  GetYearsOfOperation,
  GetCategories,
} from "../../API/endpoints/Common";
// import PartnerAgreement from "./PartnerAgreement";
import {
  createNewPartner,
  getPartnerByID,
  hardDeletePartner,
  updatePartner,
  uploadPartnerFile,
} from "../../API/endpoints/Partner";
// @ts-ignore
import Cookies from "js-cookie";
import Navbar from "../components/header/NavBar";
import { GetUserProfile } from "../../API/endpoints/User";
import ToastMessage from "../components/toasts/ToastMessage";
import {
  GetPermissionsByRoleAndModuleID,
  GetRoleById,
} from "../../API/endpoints/RolesAndPermissions/Roles";
import PartnerServicePoc from "./PartnerServicePoc";
import { GetEngagementModels } from "../../API/endpoints/Brands";
import { EngagementModelDTO } from "../dtos/brand.dtos";
import { GetAllServices } from "../../API/endpoints/Discovery";
import { GetRegionsList } from "../../API/endpoints/Regions";
import { buildFormData } from "../../common/helpers";
import { createMarket } from "../../API/endpoints/Market";

function AddPartner() {
  const params = useParams();
  const navigate = useNavigate();
  const [defaultTab, setDefaultTab] = useState<any>("partner-info");
  const [partnerID, setPartnerID] = useState(
    params?.partnerid ? params.partnerid : undefined
  );
  const [years, setYears] = useState([]);
  const [countries, setCountries] = useState([]);
  const [marketPresenceCountries, setMarketPresenceCountries] = useState([]);
  const [servicesList, setServicesList] = useState<any[]>([]);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isActivePartner, setIsActivePartner] = useState(false);
  const [partnerName, setPartnerName] = useState<string>("");
  const [userID, setUserID] = useState<string | undefined>("");
  const [userProfile, setUserProfile] = useState<any>({});
  const [notification, setNotification] = useState({ type: "", msg: "" });
  const [categories, setCategories] = useState([]);
  const [roleID, setRoleID] = useState<number>(0);
  const [permissions, setPermissions] = useState<any[]>([]);
  const [reload, setReload] = useState(false);
  const [engagementModelList, setEngagementModelList] = useState<
    EngagementModelDTO[]
  >([]);
  const [regionList, setRegionList] = useState([]);

  const [overviewData, setOverviewData] = useState({});
  const [serviceCapabilitiesData, setServiceCapabilitiesData] = useState([]);
  const [pocData, setPocData] = useState({});
  const [frmData, setFrmData] = useState<any>({
    overViewData: new FormData(),
    portfolioData: new FormData(),
    agreementData: new FormData(),
  });

  const [submitLoading, setSubmitLoading] = useState(false);

  useEffect(() => {
    setUserID(Cookies.get("userID"));
    getEngagementModelsList();
  }, []);

  useEffect(() => {
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setRoleID(response.data?.user_roles[0]?.roles.id);
          // setPartnerID(response.data?.partner_id);
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID]);

  useEffect(() => {
    if (roleID) {
      (async () => {
        const roleDetails = await GetRoleById(roleID.toString());

        if (roleDetails?.data?.type === "partner") {
          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "12"
          );
          setPermissions(response?.data);
        } else if (roleDetails?.data?.type === "administrative") {
          const response = await GetPermissionsByRoleAndModuleID(
            roleID.toString(),
            "4"
          );
          setPermissions(response?.data);
        }
      })();
    }
  }, [roleID]);

  useEffect(() => {
    if (permissions[0]?.permission_type.toString() === "1") {
      setIsSuperAdmin(true);
    }
  }, [permissions]);

  useEffect(() => {
    (async () => {
      const countries = await GetAllCountries(-1);
      setCountries(countries.data);
    })();
    (async () => {
      const countries = await GetMarketPresenceCountries();
      setMarketPresenceCountries(countries.data);
    })();
    (async () => {
      const years = await GetYearsOfOperation();
      setYears(years.data);
    })();
    (async () => {
      try {
        const response = await GetCategories();
        setCategories(
          response.data.map((item: any) => {
            return { ...item, id: item.display_name };
          })
        );
      } catch (error) {}
    })();
    (async () => {
      try {
        const response = await GetRegionsList();
        setRegionList(response.data);
      } catch (error) {}
    })();
    getEngagementModelsList();
    getServicesList();
  }, []);

  useEffect(() => {
    if (params.defaultTab) {
      setDefaultTab(params.defaultTab);
    }
  }, [params]);

  useEffect(() => {
    if (
      permissions[0]?.sub_modules[0]?.permissions_actions[1]?.permission[0]
        ?.permission === true
    ) {
      setDefaultTab("partner-info");
    } else if (
      permissions[0]?.sub_modules[1]?.permissions_actions[1]?.permission[0]
        ?.permission === true
    ) {
      setDefaultTab("partner-team");
    } else if (
      permissions[0]?.sub_modules[2]?.permissions_actions[1]?.permission[0]
        ?.permission === true
    ) {
      setDefaultTab("partner-service-capabilities");
    }
  }, [permissions]);

  useEffect(() => {
    if (partnerID) {
      (async () => {
        let res = await getPartnerByID(partnerID);
        setPartnerName(res.data.name);
        setPocData({
          first_name: res.data?.poc_firstname,
          last_name: res.data?.poc_lastname,
          designation: res.data?.poc_designation,
          email: res.data?.poc_email,
          phone: res.data?.poc_phone,
          contact_number_code: res.data?.poc_countrycode,
        });
        setServiceCapabilitiesData(res.data.market);

        if (res.data.status === "Invitation Sent") {
          setIsActivePartner(true);
        }
      })();
    }
  }, [partnerID, reload]);

  useEffect(() => {
    setUserID(Cookies.get("userID"));
    if (userID) {
      (async () => {
        const response = await GetUserProfile(userID);
        if (response?.data) {
          setUserProfile(response?.data);
        }
      })();
    }
  }, [userID]);

  const getEngagementModelsList = async () => {
    const response = await GetEngagementModels();
    if (response) {
      setEngagementModelList(response.data);
    }
  };

  const getServicesList = async () => {
    const response = await GetAllServices();
    if (response) {
      // const postServices: any[] = response?.data?.post_launch_service;
      // const preServices: any[] = response?.data?.pre_launch_service;
      const services = [
        {
          id: 1,
          name: "regulatory_compliance",
          display_name: "Regulatory Compliance",
        },
        {
          id: 2,
          name: "importation_clearance",
          display_name: "Importation & Clearance",
        },
        {
          id: 3,
          name: "warehousing_storage",
          display_name: "Warehousing & Storage",
        },
        {
          id: 4,
          name: "ecom_setup_mgmt",
          display_name: "Ecommerce Setup & Management",
        },
        {
          id: 5,
          name: "retail_distribution",
          display_name: "Retail Distribution",
        },
        {
          id: 6,
          name: "order_fulfilment",
          display_name: "Order Fulfilment",
        },
        {
          id: 7,
          name: "marketing",
          display_name: "Marketing",
        },
      ];
      setServicesList([...services]);
    }
  };

  const handleCloseNotification = () =>
    setNotification({
      type: "",
      msg: "",
    });
  const handleNotification = (type: string, msg: string) => {
    setNotification({
      type: type,
      msg: msg,
    });
  };

  const onHandleContinue = (
    tab: string,
    status: boolean,
    data?: any | {},
    frmData?: any
  ) => {
    if (status) {
      switch (tab) {
        case "overview":
          setOverviewData(data);
          if (frmData) {
            setFrmData({
              overviewData: frmData.overViewData,
              portfolioData: frmData.portfolioData,
              agreementData: frmData.agreementData,
            });
          }
          setDefaultTab("partner-service-capabilities");
          break;
        case "partner-service-capabilities":
          setServiceCapabilitiesData(data);
          setDefaultTab("poc");
          break;

        case "poc":
          setPocData(data);
          onCreateNewPartner(overviewData, serviceCapabilitiesData, data);
          break;

        default:
          break;
      }
    }
  };

  const onCreateNewPartner = (overview: any, services: any[], poc: any) => {
    setSubmitLoading(true);
    const overviewReq = {
      created_by: userProfile?.id,
      name: overview?.name,
      country_of_origin: overview?.country_of_origin,
      website: overview?.website?.trim(),
    };

    const servicesReq = {
      service_capabilities: services.map((item) => {
        return {
          market: item?.market?.id,
          services: item?.services?.map((service: any) => service?.name),
          engagement_model: item?.engagement_model?.map(
            (model: any) => model?.name
          ),
          shipment_terms: item?.shipment_terms?.map((terms: any) => terms?.id),
          payment_terms: item?.payment_terms?.map((terms: any) => terms?.id),
          category_focus: item?.category_focus?.map((cat: any) => cat?.id),
          exclusivity: item?.exclusivity?.id,
          minimum_tenure: item?.minimum_tenure?.name,
          investments: item?.investments?.id,
          remarks: item?.remarks,
        };
      }),
    };

    const pocReq = {
      poc_firstname: poc?.first_name,
      poc_lastname: poc?.last_name,
      poc_designation: poc?.designation,
      poc_email: poc?.email,
      poc_countrycode: poc?.contact_number_code,
      poc_phone: poc?.phone,
    };

    createNewPartner(overviewReq)
      .then(async (partnerRes) => {
        if (partnerRes?.data?.id) {
          updatePartner(pocReq, partnerRes.data.id)
            .then(async (res) => {
              try {
                const overviewData = frmData?.overviewData;
                overviewData.has("partner_id")
                  ? overviewData.set("partner_id", partnerRes.data.id)
                  : overviewData.append("partner_id", partnerRes.data.id);

                const portfolioData = frmData?.portfolioData;
                portfolioData.has("partner_id")
                  ? portfolioData.set("partner_id", partnerRes.data.id)
                  : portfolioData.append("partner_id", partnerRes.data.id);

                const agreementData = frmData?.agreementData;
                agreementData.has("partner_id")
                  ? agreementData.set("partner_id", partnerRes.data.id)
                  : agreementData.append("partner_id", partnerRes.data.id);

                const overviewUpload = await uploadPartnerFile(overviewData);
                const portfolioUpload = await uploadPartnerFile(portfolioData);
                const agreementUpload = await uploadPartnerFile(agreementData);

                // if (
                //   overviewUpload.msg === "Documents uploaded successfully" ||
                //   portfolioUpload.msg === "Documents uploaded successfully" ||
                //   agreementUpload.msg === "Documents uploaded successfully"
                // ) {
                //   props.onContinue("overview", true, frmData);
                // }

                servicesReq.service_capabilities.forEach(async (item) => {
                  const marketReq = {
                    partner_id: partnerRes.data.id,
                    region: item?.market,
                    service_capabilities: item?.services,
                    category_focus: item?.category_focus,
                    exclusivity: item.exclusivity,
                    minimum_tenure: item.minimum_tenure,
                    shipment_terms: item?.shipment_terms,
                    engagement_model: item.engagement_model,
                    payment_terms: item.payment_terms,
                    trade_marketing_investments: item.investments,
                    remarks: item.remarks ? item.remarks : undefined,
                  };
                  const createdRes = await createMarket(marketReq);
                });

                setNotification({
                  type: "success",
                  msg: "Partner Created Successfully",
                });
                setSubmitLoading(false);
                navigate(-1);
              } catch (error: any) {
                setSubmitLoading(false);
                const deletedPartner = await hardDeletePartner(
                  partnerRes?.data?.id
                );
                console.log("err", error);
                setNotification({
                  type: "error",
                  msg: error?.msg ? error.msg : "unable to create partner",
                });
              }
            })
            .catch(async (error: any) => {
              setSubmitLoading(false);
              const deletedPartner = await hardDeletePartner(
                partnerRes?.data?.id
              );
              console.log("err", error);
              setNotification({
                type: "error",
                msg: error?.msg ? error.msg : "unable to create partner",
              });
            });
        }
      })
      .catch((err) => console.log("err", err));

    // buildFormData(frmData, { ...overviewReq, ...servicesReq, ...pocReq });
  };

  return (
    <Container fluid className="addpartner">
      <Row>
        <Col className="sidebar">
          <Sidebar active={"partner"} />
        </Col>
        <Col className="content-main p-0">
          <Container fluid className="parent-container">
            <Row>
              <Col className="p-0">
                <Navbar userProfile={userProfile} />
              </Col>
            </Row>
            <Row>
              <Col className="breadcrumb-nav">
                <Breadcrumb>
                  <Breadcrumb.Item className="font12-regular gray-500">
                    <Link to="/PartnerManagement">PARTNER MANAGEMENT</Link>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item className="font12-medium gray-800">
                    {params?.partnerid
                      ? partnerName.toLocaleUpperCase()
                      : "ADD NEW PARTNER"}
                  </Breadcrumb.Item>
                  {params?.partnerid && (
                    <Breadcrumb.Item active className="font12-medium gray-800">
                      {params?.partnerid ? "EDIT PARTNER" : ""}
                    </Breadcrumb.Item>
                  )}
                </Breadcrumb>
              </Col>
            </Row>
            <Row className="tabs-row">
              <Col className="p-0">
                <Tabs
                  activeKey={defaultTab}
                  onSelect={(k) => {
                    if (params?.partnerid) {
                      setDefaultTab(k);
                    }
                  }}
                  id="fill-tab-example"
                  className="tabs-global"
                  fill
                >
                  {permissions[0]?.sub_modules[0]?.permissions_actions[1]
                    ?.permission[0]?.permission && (
                    <Tab
                      eventKey="partner-info"
                      title={
                        <React.Fragment>
                          <div>Partner Overview</div>
                        </React.Fragment>
                      }
                    >
                      {/* <PartnerServiceCapabilitiesNew
                        countries={marketPresenceCountries}
                        partnerID={partnerID}
                        isActivePartner={isActivePartner}
                        isSuperAdmin={isSuperAdmin}
                        permissions={permissions}
                      />   */}
                      {/* <PartnerServicePoc /> */}
                      <PartnerOverviewForm
                        countries={countries}
                        years={years}
                        setPartnerID={setPartnerID}
                        setDefaultTab={setDefaultTab}
                        handleNotification={handleNotification}
                        onContinue={onHandleContinue}
                        categories={categories}
                        permissions={permissions}
                        userName={`${userProfile?.first_name} ${userProfile?.last_name}`}
                        userID={userProfile?.id}
                        data={overviewData}
                      />
                    </Tab>
                  )}
                  {permissions[0]?.sub_modules[2]?.permissions_actions[1]
                    ?.permission[0]?.permission && (
                    <Tab
                      eventKey="partner-service-capabilities"
                      title={
                        <React.Fragment>
                          <div>Service Capabilities</div>
                        </React.Fragment>
                      }
                    >
                      <PartnerServiceCapabilitiesNew
                        countries={marketPresenceCountries}
                        engagementModelList={engagementModelList}
                        partnerID={partnerID}
                        isActivePartner={isActivePartner}
                        isSuperAdmin={isSuperAdmin}
                        permissions={permissions}
                        categories={categories}
                        tenureList={years}
                        servicesList={servicesList}
                        setDefaultTab={setDefaultTab}
                        data={serviceCapabilitiesData}
                        onContinue={onHandleContinue}
                        reload={() => setReload(!reload)}
                      />
                    </Tab>
                  )}
                  {permissions[0]?.sub_modules[1]?.permissions_actions[1]
                    ?.permission[0]?.permission && (
                    <Tab
                      eventKey="poc"
                      title={
                        <React.Fragment>
                          <div>POC</div>
                        </React.Fragment>
                      }
                    >
                      <PartnerServicePoc
                        onContinue={onHandleContinue}
                        regionList={regionList}
                        partnerID={partnerID}
                        data={pocData}
                        submitLoading={submitLoading}
                      />
                    </Tab>
                  )}
                </Tabs>
              </Col>
            </Row>
          </Container>
          <ToastMessage
            notification={notification}
            onCancel={handleCloseNotification}
          />
        </Col>
      </Row>
    </Container>
  );
}

export default AddPartner;
